<template>
  <div class="mc-liveview__map">
    <GmapMap
      id="map"
      ref="MapAddress"
      :center="center"
      :zoom="zoom"
      :options="gMapOptions"
      class="mc-map mc-map--route"
      map-type-id="roadmap"
    >
      <gmap-custom-marker
        v-for="(row, index) in primaryLoc"
        :key="`primary-${index}`"
        :marker="{
          lat: Number(row.lat),
          lng: Number(row.lng),
        }"
        :offsetY="40"
      >
        <div v-if="primaryLoc" class="text-center mc-map--route-marker">
          <img alt="marker" src="@/assets/images/caricon/primary-loc.svg" />
          <span>{{ row.locOrder }}</span>
        </div>
      </gmap-custom-marker>
      <template v-if="alternateLoc.length">
        <gmap-custom-marker
          v-for="(row, index) in alternateLoc"
          :key="`alternate-${index}`"
          :marker="{
            lat: Number(row.lat),
            lng: Number(row.lng),
          }"
          :offsetY="60"
        >
          <div v-if="alternateLoc" class="text-center mc-map--route-marker">
            <img alt="marker" src="@/assets/images/caricon/alt-loc.svg" />
            <span>{{ row.locOrder }}</span>
          </div>
        </gmap-custom-marker>
      </template>
    </GmapMap>
  </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import { Helper } from '@/mixin/helper'
import responsive from '@/mixin/responsive'

export default {
  name: 'GmapFleet',
  components: {
    'gmap-custom-marker': GmapCustomMarker,
  },
  mixins: [Helper, responsive],
  data() {
    return {
      map: null,
      gMapOptions: {},
      center: { lat: -2.958881, lng: 109.5543666 },
      zoom: 5.56,
      directionsService: null,
      directionsRenderer: null,
      allPath: [],
      primaryLoc: [],
      alternateLoc: [],
    }
  },
  computed: {
    google: gmapApi,
  },
  async mounted() {
    const self = this

    await this.$refs.MapAddress.$mapPromise.then((map) => {
      let directionsService = new this.google.maps.DirectionsService()
      let directionsRenderer = new this.google.maps.DirectionsRenderer({
        suppressMarkers: false,
      })
      self.map = map

      this.directionsService = directionsService
      this.directionsRenderer = directionsRenderer

      self.gMapOptions = {
        minZoom: 3,
        mapTypeControl: false,
        zoomControl: true,
        zoomControlOptions: {
          position: self.google.maps.ControlPosition.LEFT_BOTTOM,
        },
        scaleControl: true,
        streetViewControl: true,
        streetViewControlOptions: {
          position: self.google.maps.ControlPosition.LEFT_BOTTOM,
        },
        fullscreenControl: false,
      }
    })
    this.$root.$on('polyLine', function (polylineCoordinates, priority, location) {
      self.createLine(polylineCoordinates, priority, location)
    })
    this.$root.$on('resetPolyline', function () {
      self.resetPolyline()
    })
    this.$root.$on('setRouteMarker', function (priority, coordinate) {
      self.setMarker(priority, coordinate)
    })
    this.$root.$on('boundingMap', function (payload) {
      self.boundingMap(payload)
    })
  },
  methods: {
    boundingMap(pos) {
      let bounds = new this.google.maps.LatLngBounds()
      pos.forEach((row) => {
        bounds.extend(row)
      })

      this.map.fitBounds(bounds)
    },

    async createLine(polylineCoordinates, priority, location) {
      let bounds = new this.google.maps.LatLngBounds()
      const polylines = []
      for (let i = 0; i < polylineCoordinates.length - 1; i++) {
        polylines.push(
          new this.google.maps.LatLng(polylineCoordinates[i].lat, polylineCoordinates[i].long)
        )
        polylines.push(
          new this.google.maps.LatLng(
            polylineCoordinates[i + 1].lat,
            polylineCoordinates[i + 1].long
          )
        )
        bounds.extend(
          new this.google.maps.LatLng(polylineCoordinates[i].lat, polylineCoordinates[i].long)
        )
      }
      // create a polyline
      let path = new this.google.maps.Polyline({
        path: polylines,
        geodesic: true,
        strokeOpacity: 1.0,
        strokeWeight: 8,
      })

      this.allPath.push(path)
      // // set the color of the segment based on the lowest index point

      if (priority == 0) {
        path.setOptions({
          strokeColor: '#0D4491',
          zIndex: 99999,
        })
      } else {
        path.setOptions({
          strokeColor: '#72A8E9',
        })
      }
      this.setMarker(priority, location)
      this.map.fitBounds(bounds)
      path.setMap(this.map)
    },
    resetPolyline() {
      this.allPath.forEach((element) => {
        element.setMap(null)
      })
      this.primaryLoc.splice(0, this.primaryLoc.length)
      this.alternateLoc.splice(0, this.alternateLoc.length)
      this.allPath.splice(0, this.allPath.length)
    },
    setMarker(priority, coords) {
      const primaryLoc = []
      const alternateLoc = []
      for (let i = 0; i < coords.length; i++) {
        if (priority == 0) {
          primaryLoc.push({
            locOrder: i + 1,
            lat: coords[i].lat,
            lng: coords[i].long,
          })
        } else {
          alternateLoc.push({
            locOrder: i + 1,
            lat: coords[i].lat,
            lng: coords[i].long,
          })
        }
      }
      if (priority == 0) {
        const jsonObject = primaryLoc.map(JSON.stringify)
        const uniqueSet = new Set(jsonObject)
        this.primaryLoc = Array.from(uniqueSet).map(JSON.parse)
      } else {
        const jsonObject = alternateLoc.map(JSON.stringify)
        const uniqueSet = new Set(jsonObject)
        this.alternateLoc = Array.from(uniqueSet).map(JSON.parse)
      }
    },
  },
}
</script>
